var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLogout = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "globe")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0.-Menu-General-",
    transform: "translate(-34.000000, -982.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(1.000000, 795.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Parameters",
    transform: "translate(32.000000, 184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.998265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Action-/-exit_to_app",
    transform: "translate(0.000000, 1.199479)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 13.8974164 0 13.8974164 13.8974164 0 13.8974164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84270548,9.02753008 L6.6591787,9.84400329 L9.55447378,6.94870821 L6.6591787,4.05341312 L5.84270548,4.86988633 L7.33667775,6.36964919 L1.73717705,6.36964919 L1.73717705,7.52776722 L7.33667775,7.52776722 L5.84270548,9.02753008 Z M11.0021213,1.73717705 L2.89529509,1.73717705 C2.25253958,1.73717705 1.73717705,2.25833017 1.73717705,2.89529509 L1.73717705,5.21153115 L2.89529509,5.21153115 L2.89529509,2.89529509 L11.0021213,2.89529509 L11.0021213,11.0021213 L2.89529509,11.0021213 L2.89529509,8.68588526 L1.73717705,8.68588526 L1.73717705,11.0021213 C1.73717705,11.6390862 2.25253958,12.1602394 2.89529509,12.1602394 L11.0021213,12.1602394 C11.6390862,12.1602394 12.1602394,11.6390862 12.1602394,11.0021213 L12.1602394,2.89529509 C12.1602394,2.25833017 11.6390862,1.73717705 11.0021213,1.73717705 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  }))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logout.fda7d319.svg";
export { ForwardRef as ReactComponent };